/** Backend / UI use different shapes: linkedProductItemId, productItem._id, linkedProductItem._id, etc. */
export function resolveLinkedProductItemId(source: any): string | undefined {
  if (!source || typeof source !== "object") return undefined;
  const id =
    source.linkedProductItemId ??
    source.productItem?._id ??
    source.productItem?.id ??
    source.linkedProductItem?._id ??
    source.linkedProductItem?.id;
  if (id == null || id === "") return undefined;
  return typeof id === "string" ? id : String(id);
}
